/* Used for push notifications, cookies and popups. */
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Transition from 'react-transition-group/Transition';
import Button from '../Elements/Button/Button';
import Newsletter from '../Footer/Newsletter';
import { addEvent, removeEvent, purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Notification.scss';

let notificationBannerSpeed = null;
let scrollingTimer1 = null;
let scrollingInterval1 = null;
let scrollingInterval2 = null;

class Notification extends Component {
	campaignCycle = false;

	constructor(props) {
		super(props);

		this.notificationInner = React.createRef();
		this.notificationBanner = React.createRef();

		this.state = {
			notificationIndex: 0,
			messageScrolling: false,
			messageScrollingSpeed: 1,
			delay: {},
		};
	}

	componentDidMount() {
		const started = window.performance.now();
		const { type, content = [] } = this.props;
		const notifications = content.filter((n) => n?.text);
		let isMessageScrolling = false;

		notifications.forEach((item) => {
			const notificationName = urlify(item.name);
			if (item.delay) {
				this.setState((prevState) => ({
					delay: {
						...prevState.delay,
						[notificationName]: false,
					},
				}));
				setTimeout(() => {
					this.setState((prevState) => ({
						delay: {
							...prevState.delay,
							[notificationName]: true,
						},
					}));
				}, parseInt(item.delay, 10) * 1e3);
			}
		});

		const toggleMessagescrolling = () => {
			if (window.innerWidth < 1100 && !isMessageScrolling) {
				isMessageScrolling = true;
				this.setState({
					messageScrolling: 1,
					messageScrollingSpeed: notificationBannerSpeed,
				});
				scrollingTimer1 = setTimeout(() => {
					// Initiate scrolling of text
					this.setState({ messageScrolling: 2 });
				}, 40);
				scrollingInterval1 = setInterval(() => {
					// Reset scrolling
					this.setState({ messageScrolling: 3 });
				}, (15 * notificationBannerSpeed * 1e3) - 40);
				scrollingInterval2 = setInterval(() => {
					// Nth scrolling
					this.setState({ messageScrolling: 4 });
				}, 15 * notificationBannerSpeed * 1e3);
			} else if (window.innerWidth > 1100 && isMessageScrolling) {
				isMessageScrolling = false;
				this.setState({ messageScrolling: false });
				clearTimeout(scrollingTimer1);
				clearInterval(scrollingInterval1);
				clearInterval(scrollingInterval2);
			}
		};

		addEvent(window, 'resize.windowResize', () => {
			toggleMessagescrolling();
		});

		const initiateSiteListeners = () => {
			if (!notifications && started + 2000 < window.performance.now()) {
				setTimeout(initiateSiteListeners, 200);
			}

			if (this.notificationBanner.current && notificationBannerSpeed === null) {
				notificationBannerSpeed = Math.ceil((this.notificationBanner.current.children[0].textContent.length * 0.5) / 15);
				toggleMessagescrolling();
			}

			if (notifications && notifications.length > 1 && type === 'campaign') {
				this.campaignCycle = setInterval(() => {
					this.setState((prevState) => ({ notificationIndex: prevState.notificationIndex + 1 }));
				}, 4000);
			}
		};

		initiateSiteListeners();
	}

	componentWillUnmount() {
		clearInterval(this.campaignCycle);
		clearTimeout(scrollingTimer1);
		clearInterval(scrollingInterval1);
		clearInterval(scrollingInterval2);
		removeEvent(window, 'resize.windowResize');
		removeEvent(document.querySelector('body'), 'click.notificationClose');
	}

	removeNotificationHandler = (e) => {
		if (e) e.preventDefault();

		const $notificationElement = this.notificationInner.current;
		const cookieName = $notificationElement.dataset.name;
		const cookieDuration = $notificationElement.dataset.duration;

		let date = new Date();
		date = date.setTime(date.getTime() + (cookieDuration * 1000));

		const expires = `expires=${new Date(date).toGMTString()}; `;

		document.cookie = `${cookieName}=1; ${expires}path=/`;

		// Notify Redux that we have removed the item.
		this.props.notificationRemoved();
		this.props.removeNotification(this.props.type, cookieName);
	}

	render() {
		const { type, content, setup, headerShowingMobile = false } = this.props;
		const { notificationIndex, delay, messageScrolling, messageScrollingSpeed } = this.state;

		if (!content) return null;
		const notifications = content.filter((n) => n?.text && ((n.countryRestrict && n.countryRestrict.indexOf(setup.country) !== -1) || !n.countryRestrict));

		const newsletterSubmitHandler = () => {
			setTimeout(() => {
				this.removeNotificationHandler();
			}, 500);
		};

		return (
			<div className={[s.notification, s[`notification__scrollingSpeed${messageScrollingSpeed}`], (headerShowingMobile ? s.notification__showing : null), s[`notification__${type}`]].join(' ')}>
				{
					notifications.map((item, i) => {
						const notificationName = urlify(item.name);
						const notificationAttributes = {
							style: {},
						};
						const notificationInnerClasses = [s.inner, (item.removeText ? [s.inner__closeText] : null)];

						if (item.textColor) notificationAttributes.style.color = item.textColor;
						if (item.backgroundColor) notificationAttributes.style.backgroundColor = item.backgroundColor;
						if (item.stickToBottom) notificationInnerClasses.push(s.inner__stickToBottom);
						if (notificationIndex % notifications.length === i) notificationInnerClasses.push(s.inner__selected);

						// Check for cookies which are already set.
						if ((item.removable || type === 'popup') && item.cookieDuration) {
							let cookieIsSet = false;

							const cookies = typeof document !== 'undefined' ? document.cookie : setup.cookies;
							if (typeof cookies === 'object') {
								if (cookies[notificationName]) cookieIsSet = true;
							} else if (cookies) {
								cookies.split(';').forEach((cookie) => {
									// Cookie is set don't display notification.
									if (cookie.indexOf(notificationName) !== -1) cookieIsSet = true;
								});
							}

							// Item shown already.
							if (cookieIsSet && item.removed !== true) return null;
							// Item delayed don't show yet.
							if (item.delay && !delay[notificationName]) return null;

							notificationAttributes['data-name'] = notificationName;
							notificationAttributes['data-duration'] = item.cookieDuration;

							if (Object.keys(notificationAttributes.style).length === 0) delete notificationAttributes.style;
						}

						let innerTextContent = translate(setup, item?.text).replace('%country%', setup.countries[setup.country].name);
						const innerTextClasses = [s.inner_text];

						if (type === 'campaign' && messageScrolling) {
							innerTextContent = `${innerTextContent}${innerTextContent}${innerTextContent}`;
							if (messageScrolling === 1) {
								innerTextClasses.push(s.inner_text__scrolling);
							}
							if (messageScrolling === 2) {
								innerTextClasses.push(s.inner_text__scrollingFirst);
							}
							if (messageScrolling === 3) {
								innerTextClasses.push(s.inner_text__scrollingNthStart);
							}
							if (messageScrolling === 4) {
								innerTextClasses.push(s.inner_text__scrollingNthEnd);
							}
						}

						innerTextContent = `<div>${innerTextContent}</div>`;

						return (
							<Transition in={item.removed !== true} timeout={300} key={notificationName} unmountOnExit>
								{(state) => (
									<>
										{ type === 'popup' && <button className={[s.notification_screen, s[`notification_screen__${state}`]].join(' ')} type="button" onClick={this.removeNotificationHandler} aria-label="Close" /> }
										<div ref={this.notificationInner} className={[...notificationInnerClasses, s[`inner__${state}`]].join(' ')} {...notificationAttributes}>
											<div className={s.inner_wrapper}>
												<div ref={this.notificationBanner} className={innerTextClasses.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(innerTextContent) }} />
												{
													item.includeNewsletter ? <div className={s.inner_newsletter}><Newsletter callback={newsletterSubmitHandler} variant="Popup" /></div> : null
												}
												{
													(item.removable || type === 'popup') && item.cookieDuration && (
														<div className={s.inner_close} style={{ backgroundColor: notificationAttributes?.style?.backgroundColor || 'transparent' }}>
															<Button type="button" clickEventHandler={this.removeNotificationHandler} variantClasses={item.removeText ? ['button__inverse'] : ['button__invisible']}>
																{
																	item.removeText && translate(setup, item.removeText)
																}
																{
																	!item.removeText && (
																		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M13 1L1 13" />
																			<path d="M1 1L13 13" />
																		</svg>
																	)
																}
															</Button>
														</div>
													)
												}
											</div>
										</div>
									</>
								)}
							</Transition>
						);
					})
				}
			</div>
		);
	}
}

export default hot(module)(Notification);
